/**
 * Dark mode (Lucas, 2026-10-14, request 141).
 *
 * Three states. Nothing stored: the device setting decides (the tokens in
 * snippets/css-variables.liquid answer prefers-color-scheme). "dark" or
 * "light" stored in localStorage "fmt:theme": that wins, applied before
 * paint by the inline script in layout/theme.liquid and kept here. The
 * header button flips between them and stores the result; its pressed
 * state shows which one the page is in right now.
 */
(function () {
  'use strict';

  var KEY = 'fmt:theme';
  var root = document.documentElement;
  var media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  function stored() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }

  /** "dark" or "light": the stored choice, else the device's. */
  function effective() {
    var mode = stored();
    if (mode === 'dark' || mode === 'light') return mode;
    return media && media.matches ? 'dark' : 'light';
  }

  function paint() {
    var dark = effective() === 'dark';
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', dark ? 'true' : 'false');
      buttons[i].setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
      buttons[i].title = dark ? 'Light mode' : 'Dark mode';
    }
  }

  function set(mode) {
    try { localStorage.setItem(KEY, mode); } catch (e) { /* storage blocked: this visit only */ }
    root.setAttribute('data-theme', mode);
    paint();
    document.dispatchEvent(new CustomEvent('theme:changed', { detail: { mode: mode } }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    set(effective() === 'dark' ? 'light' : 'dark');
  });

  // The device changing its mind matters only while nothing is stored.
  if (media && media.addEventListener) media.addEventListener('change', function () { if (!stored()) paint(); });

  window.ThemeMode = { effective: effective, set: set, stored: stored };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
})();
